import React, { useState } from 'react';
import { TitleHeader } from 'web-library';
import { useParams } from 'react-router-dom';
import RegistrationSummaryList from '../../../../modules/examRegistration/components/nonNationalExam/RegistrationSummaryList';
import { useGetRegistrationSummaryPDF } from '../../../../api-refactored/non-national-exam-registration/useGetRegistrationSummaryPDF';
import { useGetNonNationalExamSummary } from '../../../../api-refactored/non-national-exam-registration/useGetNonNationalExamSummary';
import LoadingComponent from '../../../../components/LoadingComponent';
import DownloadProgressModal from '../../../../components/modals/DownloadProgressModal';
import { FileUploadState } from '../../../../models/File';

interface SummaryPathParams {
  uuid: string;
}

interface AeisRegistrationSummaryProps {
  isTransactionHistory?: boolean;
}

const AeisRegistrationSummary = ({ isTransactionHistory }: AeisRegistrationSummaryProps) => {
  const { uuid } = useParams<SummaryPathParams>();
  const [fileStatus, setFileStatus] = useState(FileUploadState.IDLE);

  // TODO: make API call here
  const { refetch, isFetching } = useGetRegistrationSummaryPDF({
    uuid,
    onSuccess: (res) => {
      const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    },
    onError: (_) => {
      setFileStatus(FileUploadState.FAILED);
    },
  });

  const { data } = useGetNonNationalExamSummary({
    uuid,
  });

  const handleCloseDownloadErrorPrompt = () => {
    setFileStatus(FileUploadState.IDLE);
  };

  return (
    <>
      {data ? (
        <>
          <TitleHeader title="View Registration" />
          <RegistrationSummaryList
            data={data}
            isAEIS
            refetch={refetch}
            isFetching={isFetching}
            isTransactionHistory={isTransactionHistory}
          />
          {fileStatus === FileUploadState.FAILED && (
            <DownloadProgressModal
              modalState
              fileDownloadStatus={FileUploadState.FAILED}
              onDialogClose={handleCloseDownloadErrorPrompt}
            />
          )}
        </>
      ) : (
        <LoadingComponent />
      )}
    </>
  );
};

export default AeisRegistrationSummary;
